module.exports = __webpack_public_path__ + "static/media/fail-cross.f973179e.svg";